export enum CompetitionCategory {
  RX = 'RX',
  SCALED = 'SCALED',
}

export enum CompetitionType {
  INDIVIDUAL = 'INDIVIDUAL',
  TEAM = 'TEAM',
}

export interface BaseCompetitor {
  id: string;
  category: CompetitionCategory;
  type: string;
}

export interface IndividualCompetitor extends BaseCompetitor {
  type: 'INDIVIDUAL';
  athleteId: string;
}

export interface TeamCompetitor extends BaseCompetitor {
  type: 'TEAM';
  athleteIds: string[];
  name: string;
}

export type Competitor = IndividualCompetitor | TeamCompetitor;

export interface CreateIndividualCompetitorInput {
  athleteId: string;
  category: CompetitionCategory;
}

export interface CreateTeamCompetitorInput {
  athleteIds: string[];
  name: string;
  category: CompetitionCategory;
}

export function isTeamCompetitor(competitor: Competitor): competitor is TeamCompetitor {
  return competitor.type === 'TEAM' || ('athleteIds' in competitor && 'name' in competitor);
}

export function isIndividualCompetitor(competitor: Competitor): competitor is IndividualCompetitor {
  return competitor.type === 'INDIVIDUAL' || 'athleteId' in competitor;
}
